var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUlaLupa = function SvgUlaLupa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.9 23.6-4.85-4.8 2.1-2.1 2.7 2.7 5-5 2.1 2.1-7.05 7.1Zm21.9 18.35L26.65 28.8c-1 .867-2.167 1.542-3.5 2.025-1.333.483-2.75.725-4.25.725-3.6 0-6.65-1.25-9.15-3.75S6 22.283 6 18.75c0-3.533 1.25-6.55 3.75-9.05 2.5-2.5 5.533-3.75 9.1-3.75 3.533 0 6.542 1.25 9.025 3.75 2.483 2.5 3.725 5.517 3.725 9.05 0 1.433-.233 2.817-.7 4.15a12.694 12.694 0 0 1-2.1 3.75L42 39.75l-2.2 2.2Zm-20.95-13.4c2.7 0 5-.958 6.9-2.875 1.9-1.917 2.85-4.225 2.85-6.925s-.95-5.008-2.85-6.925c-1.9-1.917-4.2-2.875-6.9-2.875-2.733 0-5.058.958-6.975 2.875C9.958 13.742 9 16.05 9 18.75s.958 5.008 2.875 6.925c1.917 1.917 4.242 2.875 6.975 2.875Z",
    fill: "#3B877E"
  })));
};
export default SvgUlaLupa;